

import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'

import i18n from '@/plugins/i18n'
import { getTimeLimitGroupsWithSchedules,generateScheduleGrid,getTimeLimitGroups, setMinimumGird, insertT2050WorkCellsIntoGrid, insertSupportCellsIntoGrid } from './comp/gridLayoutUtils';
import { LetsMessageMap } from '@/components/autoImport/LetsMessage';
import moment from 'moment';
import $ from 'jquery'

function parseTimeLimit(timeLimitNo){
  const timeDivision = timeLimitNo%10
  const group = Math.floor(timeLimitNo/10)*10

  let frontHalfFlag= false;
  let backHalfFlag=false;
  switch (timeDivision) {
    case 0:
      frontHalfFlag= true;
      backHalfFlag=true;
      break;
    case 1:
      frontHalfFlag = true
      break;
    case 2:
      backHalfFlag = true
      break;

    default:
      console.log()
      break;
  }

  return {
    frontHalfFlag,
    backHalfFlag,
    frontHalfTimeLimitNo: group+1,
    backHalfTimeLimitNo: group+2,
    group,
    timeDivision
  }
}


function incrementLimitCounter(obj, key,increment = 1) {
  if (!obj[key]) obj[key] = 0;
  obj[key] += increment;
}

const C40101T2050Module = {
  state:{
    C40101T2050_rows: [],
    C40101T2050_map: {},
  },
  getters:{
    C40101T2050_isWorkCell: (state) => ({
      schedule_date,
      time_limit_no,
      teacher_no
    }) => {
      if (!schedule_date) throw new Error('schedule_date is required');
      if (!time_limit_no) throw new Error('time_limit_no is required');
      if (!teacher_no) throw new Error('teacher_no is required');
      return !!state.C40101T2050_map[`${schedule_date}_${time_limit_no}_${teacher_no}`];
    },
    C40101T2050_isWorkCell_content: (state,getters) => ({
      schedule_date,
      time_limit_no,
      teacher_no,
      capacity
    }) => {
      const result = getters.C40101T2050_isWorkCell({
        schedule_date,
        time_limit_no,
        teacher_no
      });
      if(result){
        return capacity === 1 ? window.vue.$i18n.t('C11101.C11101Store.shi-wu-zuo-ye'): '↑'
      }
    },
    C40101T2050_submitApi: (state) => {
      return {
        api: 'T2050OthersScheduleService.C40101T2050_submit',
        input: {
          start_date: state.searchInfo.date[0],
          end_date: state.searchInfo.date[1],
          center_no: state.searchInfo.center,
          rows: state.C40101T2050_rows
        }
      }
    }
  },
  mutations: {
    set_C40101T2050_map: (state) => {
      const output = {};
      state.C40101T2050_rows.forEach(t2050 => {
        const key = `${t2050.schedule_date}_${t2050.time_limit_no}_${t2050.teacher_no}`;
        if(t2050._action === 'delete') return; // skip delete action
        output[key] = true;
      });
      state.C40101T2050_map = Object.freeze(output);
    },
  },
  actions:{
    async C40101T2050_toggleWork({state,commit,getters}, {
      key
    }){
      if (!key) throw new Error('key is required');
      const { schedule_date, time_limit_no, teacher_no } = getters.C40101Cell_keyParse(key)
      if (!schedule_date) throw new Error('schedule_date is required');
      if (!time_limit_no) throw new Error('time_limit_no is required');
      if (!teacher_no) throw new Error('teacher_no is required');
      const exist = state.C40101T2050_map[key];
      const row = state.C40101T2050_rows.find(r => r.schedule_date === schedule_date && r.time_limit_no === time_limit_no && r.teacher_no === teacher_no);
      const index = state.C40101T2050_rows.indexOf(row);
      console.debug({
        key,
        exist,
        row,
        index
      })
      if (exist) {
        state.C40101T2050_rows[index]._action = 'delete'
      } else{
        if(row && row._action === 'delete')
          state.C40101T2050_rows[index]._action = 'insert'
        else {
          const newRow = {
            schedule_date,
            time_limit_no,
            teacher_no,
            timeDivision: time_limit_no % 10,
            center_no: state.searchInfo.center,
            dayofweek: moment(schedule_date).isoWeekday(),
            _action :'insert',
          }
          state.C40101T2050_rows.push(newRow);
        }

      }
      commit('set_C40101T2050_map')
      commit('setState',{isDirty: true})
      // ISSUE_INVESTIGATE: update only for current teacher to improve performance, but not working properly
      // commit('updateGridDataForCurrentTeacher',[teacher_no])
      commit('updateGridDataForCurrentTeacher')
    },
  }
}

/**
 * @type {import('vuex').Module}
 */
const module = {
  state: {
    searchInfo: {
      center: null,
      date: []
    },

    errorNotificationMessage: null,

    teachers: [],
    timeSlots: [],
    lessons: [],

    centers: [],
    groupCenters: [],

    selectedLessonNo: null,
    selectedLessonExtraInfo: null,

    updateKey: null,

    lowUsageRateTreshold: 34,

    t3014: {open_schedule_date:null},

    isDirty: false,

    main_t2030_teacher_schedule: [],
    teacherIsAvailableMap: {},

    C40101_updateScheduleCheck_B00301:null,

    C40101_canEdit_MinDate: null,
    C40101_canEdit_MaxDate: null,

    C40101_gridDataTeachers: {},
    C40101_classUsageData: {},

    C40201_ALLOW_DOWNLOAD_PDF:false,
    C40201_ALLOW_DOWNLOAD_EXCEL:false,
  },

  getters: {
    C40101Cell_keyStringtify: () => ({
      schedule_date,
      time_limit_no,
      teacher_no
    }) => {
      if (!schedule_date) throw new Error('schedule_date is required')
      if (!time_limit_no) throw new Error('time_limit_no is required')
      if (!teacher_no) throw new Error('teacher_no is required')
      return `${schedule_date}_${time_limit_no}_${teacher_no}`
    },
    C40101Cell_keyParse: () => (key) => {
      if (!key) throw new Error('key is required')
      const parts = key.split('_')
      if (parts.length !== 3) throw new Error('key is invalid')
      return {
        schedule_date: parts[0],
        time_limit_no: parseInt(parts[1], 10),
        teacher_no: parseInt(parts[2], 10),
      };
    },
    // this.$store.getters['C40101/C40101_canEdit']
    C40101_canEdit(state) {
      return function (date) {
        if (!date) return false;
        const dateMoment = moment(date);
        const minDate = moment(state.C40101_canEdit_MinDate);
        const maxDate = moment(state.C40101_canEdit_MaxDate);
        return dateMoment.isBetween(minDate, maxDate, 'day', '[]');
      }
    },
    // ! remove
    findTeacher(state) {
      return (teacherNo) => state.teachers.find(teacher => teacher.teacher_no === teacherNo) || {};
    },
    getTimeLimitGroupsWithSchedules(state) {
      return getTimeLimitGroupsWithSchedules(state.timeSlots, state.lessons, state.teachers);
    },
    getTimeLimitGroups(state) {
      return getTimeLimitGroups(state.timeSlots);
    },
    selectedLesson(state) {
      return state.lessons.find(lesson => lesson.schedule_no === state.selectedLessonNo);
    },

    getM0110Center: (state) => {
      return state.centers;
    },
    getM0110GroupCenter: (state) => {
      return state.groupCenters;
    },

    getNumberOfLessonsForEachTeacher: (state) => {
      const lessons = state.lessons.filter(lesson => lesson.teacher_no > 0);
      const teacherLessonCount = {};
      lessons.forEach(lesson => {
        incrementLimitCounter(teacherLessonCount, lesson.teacher_no);
      });
      return teacherLessonCount;
    },
    getNumberOfLessonsForEachTimeLimitNo: (state) => {
      const lessons = state.lessons
      // key = `{schedule_date}_{time_limit_no}`
      const timeLimitLessonCount = {};
      lessons.forEach(lesson => {
        const key = `${lesson.schedule_date}_${lesson.time_limit_no}`;
        incrementLimitCounter(timeLimitLessonCount, key);
      });
      return timeLimitLessonCount;
    },
    getNumberOf1to1LessonsForEachTimeLimitNo: (state) => {
      const lessons = state.lessons
      // key = `{schedule_date}_{time_limit_no}`
      const timeLimitLessonCount = {};
      lessons.forEach(lesson => {
        if(lesson.capacity !== 1) return
        const key = `${lesson.schedule_date}_${lesson.time_limit_no}`;
        incrementLimitCounter(timeLimitLessonCount, key);
      });
      return timeLimitLessonCount;
    },
    getNumberOfAvilable40MinWorkSlotPerTeacher: (state,getters) => {
      const lessons = state.lessons
      const output = {};

      // {teacher_no:{${lesson.schedule_date}_${frontHalfTimeLimitNo}:count}}
      const numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher = {}
      lessons.forEach(lesson => {
        const { frontHalfFlag,backHalfFlag,frontHalfTimeLimitNo,backHalfTimeLimitNo} =parseTimeLimit(lesson.time_limit_no)
        if(lesson.teacher_no > 0){
          if(!numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[lesson.teacher_no]){
            numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[lesson.teacher_no] = {}
          }
          if (frontHalfFlag){
            const key = `${lesson.schedule_date}_${frontHalfTimeLimitNo}`;
            incrementLimitCounter(numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[lesson.teacher_no], key, lesson.capacity);
          }
          if (backHalfFlag){
            const key = `${lesson.schedule_date}_${backHalfTimeLimitNo}`;
            incrementLimitCounter(numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[lesson.teacher_no], key, lesson.capacity);
          }
        } else {
          // doNtg
        }
      });

      // loop numberOf40MinWorkSlotPerTeacher
      const numberOf40MinWorkSlotPerTeacher = getters.getNumberOf40MinWorkSlotPerTeacher
      for (const teacherNo in numberOf40MinWorkSlotPerTeacher) {
        const baseCount = numberOf40MinWorkSlotPerTeacher[teacherNo]
        const usedMapped =numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[teacherNo]
        let finalCount = baseCount
        // console.log({baseCount,
        //   usedMapped,
        //   finalCount})
        if(usedMapped) {
          for (const asd in usedMapped) {
            const capacity = usedMapped[asd]
            if (capacity >= 1) finalCount--
          }
        }
        output[teacherNo]=finalCount
      }

      return output;
    },
    getWarningforSingleClassDayPerTeacher: (state) => {
      const lessons = state.lessons
      const output = {};

      const numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher = {}
      lessons.forEach(lesson => {
        const { frontHalfFlag,backHalfFlag} =parseTimeLimit(lesson.time_limit_no)
        const increase = 1
        if(lesson.teacher_no > 0){
          if(!numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[lesson.teacher_no]){
            numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[lesson.teacher_no] = {}
          }
          if (frontHalfFlag){
            const key = `${lesson.schedule_date}`;
            incrementLimitCounter(numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[lesson.teacher_no], key,increase);
          }
          if (backHalfFlag){
            const key = `${lesson.schedule_date}`;
            incrementLimitCounter(numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[lesson.teacher_no], key,increase);
          }
        } else {
          // doNtg
        }
      });

      // loop numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher
      for (const teacherNo in numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher) {
        const usedMapped =numberOfAssigned40MinWorkSlotPerTimeLimitPerTeacher[teacherNo]
        // console.log({usedMapped})
        if(usedMapped) {
          for (const asd in usedMapped) {
            const capacity = usedMapped[asd]
            // check that only for one class that is capacity=2 and 40min
            if (capacity === 1) output[teacherNo] = 1
          }
        }
      }

      return output;
    },
    getNumberOf40MinWorkSlotPerTeacher: (state) => {
      const teachers = state.teachers
      // key = `teacher_no`
      const output = {};
      for (let i = 0; i < teachers.length; i++) {
        const teacher = teachers[i];
        const schedulesMap = {}

        const teacherSchedules = state.main_t2030_teacher_schedule.filter(
          t2030 =>  t2030.teacher_no === teacher.teacher_no && t2030.work_flag === 1
        ).sort((a, b) => a.time_limit_no - b.time_limit_no);

        if (!teacherSchedules) continue;
        for (let j = 0; j < teacherSchedules.length; j++) {
          const teacherSchedule = teacherSchedules[j];
          const { frontHalfFlag,backHalfFlag,frontHalfTimeLimitNo,backHalfTimeLimitNo} =parseTimeLimit(teacherSchedule.time_limit_no)
          if (frontHalfFlag){
            const key = `${teacherSchedule.schedule_date}_${frontHalfTimeLimitNo}`;
            incrementLimitCounter(schedulesMap, key);
          }
          if (backHalfFlag){
            const key = `${teacherSchedule.schedule_date}_${backHalfTimeLimitNo}`;
            incrementLimitCounter(schedulesMap, key);
          }
        }
        output[teacher.teacher_no] = Object.keys(schedulesMap).length;
      }
      return output;
    },
    getNumberOfPCStateForEachTimeLimitNo: (state) => {
      const lessons = state.lessons;
      const timeLimitPCCountA1 = {};
      const timeLimitPCCountA2 = {};

      lessons.forEach(lesson => {
        const { frontHalfFlag,backHalfFlag,frontHalfTimeLimitNo,backHalfTimeLimitNo} =parseTimeLimit(lesson.time_limit_no)

        if(lesson.teacher_no > 0){
          if (frontHalfFlag){
            const key = `${lesson.schedule_date}_${frontHalfTimeLimitNo}_${lesson.teacher_no}`;
            incrementLimitCounter(timeLimitPCCountA1, key);
          }
          if (backHalfFlag){
            const key = `${lesson.schedule_date}_${backHalfTimeLimitNo}_${lesson.teacher_no}`;
            incrementLimitCounter(timeLimitPCCountA1, key);
          }
        } else {
          // １対１ …			1
          // １対２ …			0.5
          const increase = 1/lesson.capacity

          if (frontHalfFlag){
            const key = `${lesson.schedule_date}_${frontHalfTimeLimitNo}`;
            incrementLimitCounter(timeLimitPCCountA2, key,increase);
          }
          if (backHalfFlag){
            const key = `${lesson.schedule_date}_${backHalfTimeLimitNo}`;
            incrementLimitCounter(timeLimitPCCountA2, key,increase);
          }
        }
      });

      const timeLimitPCCount = timeLimitPCCountA2
      for (const key in timeLimitPCCountA1) {
        // check if key contains `_${lesson.teacher_no}`
        const teacherNo = key.split('_')[2];
        if (key.endsWith(`_${teacherNo}`)) {
          const newKey = key.split('_').slice(0, 2).join('_');
          incrementLimitCounter(timeLimitPCCount, newKey);
        }
      }

      // （0.5は繰り上げる 例：5.5 → 6）
      // loop through timeLimitPCCount, if value is not integer, round up
      for (const key in timeLimitPCCount) {
        const value = timeLimitPCCount[key];
        if (value % 1 !== 0) {
          timeLimitPCCount[key] = Math.ceil(value);
        }
      }

      return timeLimitPCCount;
    },
    getNumberOfAvailableTeachersForEachTimeLimitNo: (state) => {
      const teachers = state.teachers;
      // key = `{schedule_date}_{time_limit_no}`
      const timeLimitAvailableTeachers = {};
      for (let i = 0; i < teachers.length; i++) {
        const teacher = teachers[i];
        const teacherSchedules = state.main_t2030_teacher_schedule.filter(
          t2030 =>  t2030.teacher_no === teacher.teacher_no && t2030.work_flag === 1
        ).sort((a, b) => a.time_limit_no - b.time_limit_no);

        if (!teacherSchedules) continue;
        for (let j = 0; j < teacherSchedules.length; j++) {
          const teacherSchedule = teacherSchedules[j];

          const { frontHalfFlag,backHalfFlag,frontHalfTimeLimitNo,backHalfTimeLimitNo} =parseTimeLimit(teacherSchedule.time_limit_no)

          if (frontHalfFlag){
            const key = `${teacherSchedule.schedule_date}_${frontHalfTimeLimitNo}`;
            incrementLimitCounter(timeLimitAvailableTeachers, key);
          }
          if (backHalfFlag){
            const key = `${teacherSchedule.schedule_date}_${backHalfTimeLimitNo}`;
            incrementLimitCounter(timeLimitAvailableTeachers, key);
          }
        }
      }
      return timeLimitAvailableTeachers;
    },
    isLessonSelected: (state) => (scheduleNo) => {
      return state.selectedLessonNo === scheduleNo;
    },
    getExcelFileName(state){
      const targetCenterNo = parseInt(state.searchInfo.center);
      const targetCenter = window.vue.$store.state.Auth.m0110CenterGroup
        .find(center => center.center_no === targetCenterNo)?.center_name1 || '-';

      if(state.searchInfo.date.length !== 2) throw new Error('Date range is required for excel file name');

      // if two dates are the same, only show one date
      const dateRange = state.searchInfo.date[0] === state.searchInfo.date[1]
        ? moment(state.searchInfo.date[0]).format('YYYYMMDD')
        : `${moment(state.searchInfo.date[0]).format('YYYYMMDD')}-${moment(state.searchInfo.date[1]).format('YYYYMMDD')}`;

      return window.vue.$i18n.t('C40101.C40101Store.g5FL7ulHTbniW-LE-MlqG', [targetCenter, dateRange]);
    }
  },
  mutations: {
    setUpdateKey(state, key) {
      state.updateKey = key;
    },
    removeLesson(state, lesson) {
      const lessons = state.lessons.filter(l => l.id !== lesson.id);
      state.lessons = lessons;
    },
    setTeacherIsAvailableMap: (state) => {
      const output = {};
      state.main_t2030_teacher_schedule.forEach(t2030 => {
        if(t2030.work_flag !== 1) return; // only work_flag = 1
        const { frontHalfFlag, backHalfFlag, frontHalfTimeLimitNo, backHalfTimeLimitNo } = parseTimeLimit(t2030.time_limit_no);
        if(frontHalfFlag) {
          const key = `${t2030.schedule_date}_${frontHalfTimeLimitNo}_${t2030.teacher_no}`;
          output[key] = true;
        }
        if(backHalfFlag) {
          const key = `${t2030.schedule_date}_${backHalfTimeLimitNo}_${t2030.teacher_no}`;
          output[key] = true;
        }
      });
      state.teacherIsAvailableMap = Object.freeze(output);
    },
    /**
     * Update grid data for current teacher(s)
     * @param {Array} teacherNoList If empty, update for all teachers, otherwise only update for specified teachers
     * @returns
     */
    updateGridDataForCurrentTeacher(state,teacherNoList=[]) {
      console.time('updateGridDataForCurrentTeacher');

      const T0050Rows=state.timeSlots

      if (teacherNoList.length === 0) {
        const workingTeacherSchedules = state.main_t2030_teacher_schedule.filter(
          t2030 => t2030.work_flag === 1
        );
        if(workingTeacherSchedules.length === 0) return [];

        // get list of teacher_no
        const teacherNos = new Set([
          ...workingTeacherSchedules.map(t2030 => t2030.teacher_no),
          ...state.C40101T2050_rows.map((item) => item.teacher_no)
        ]);
        teacherNoList = Array.from(teacherNos);
        state.C40101_gridDataTeachers = {};
      }

      for (let tIndex = 0; tIndex < teacherNoList.length; tIndex++) {
        const teacherNo = teacherNoList[tIndex];
        const currentTeacherSchedules = state.lessons.filter(
          t3010 => t3010.teacher_no === teacherNo
        );
        const output = {};

        for (let dayIndex = 0; dayIndex < T0050Rows.length; dayIndex++) {
          const day = T0050Rows[dayIndex];
          const M0040Rows = day.time_limits

          if(!output[day.schedule_date]) output[day.schedule_date]={}

          const filteredTeacherSchedule = currentTeacherSchedules.filter(
            schedules => schedules.schedule_date === day.schedule_date)
          M0040Rows
            .filter(t=>t.time_division===0)
            .forEach(item=>{
              const timeGroup = Math.floor(item.time_limit_no/10)
              const schedules =  filteredTeacherSchedule.filter(schedules =>
                timeGroup === Math.floor(schedules.time_limit_no/10)
              );
              let _gridData = generateScheduleGrid(schedules)
              _gridData= setMinimumGird(_gridData,2,2)          // Check for work cells and mark them as used slots

              for(let i=1;i<=2;i++){
                _gridData = insertT2050WorkCellsIntoGrid({
                  teacherNo,
                  currentDate: day.schedule_date,
                  timeLimitNo: timeGroup * 10 + i
                },
                state.C40101T2050_map,
                _gridData)
              }
              output[day.schedule_date][timeGroup] = _gridData;
            })

          // handle support
          if(window.vue.$router.currentRoute.value.name === 'C40201') {
            const keyArr = Object.keys(output[day.schedule_date]);
            for(let i=0; i<keyArr.length; i++) {
              const key = keyArr[i];
              output[day.schedule_date][key] = insertSupportCellsIntoGrid (output[day.schedule_date][key], {
                previousGridData: i > 0 ? output[day.schedule_date][keyArr[i-1]] : null,
                nextGridData: i < keyArr.length - 1 ? output[day.schedule_date][keyArr[i+1]] : null
              })
            }
          }
        }

        state.C40101_gridDataTeachers[teacherNo] = output;
      }
      console.timeEnd('updateGridDataForCurrentTeacher');
      // state.C40101_gridDataTeachers = state.C40101_gridDataTeachers;
    },
    updateClassUsageDataForCurrentTeacher(state) {
      console.time('updateClassUsageDataForCurrentTeacher');
      const getters = window.vue.$store.getters;

      let teacherNoList = [];
      if (teacherNoList.length === 0) {
        const workingTeacherSchedules = state.main_t2030_teacher_schedule.filter(
          t2030 => t2030.work_flag === 1
        );
        if(workingTeacherSchedules.length === 0) return [];

        // get list of teacher_no
        const teacherNos = new Set(workingTeacherSchedules.map(t2030 => t2030.teacher_no));
        teacherNoList = Array.from(teacherNos);
        state.C40101_classUsageData = {};
      }

      for (let tIndex = 0; tIndex < teacherNoList.length; tIndex++) {
        const teacherNo = teacherNoList[tIndex];
        const output = {};

        output.upperUsageData = getters['C40101/getNumberOf40MinWorkSlotPerTeacher'][teacherNo]-
          getters['C40101/getNumberOfAvilable40MinWorkSlotPerTeacher'][teacherNo];
        output.lowerUsageData = getters['C40101/getNumberOf40MinWorkSlotPerTeacher'][teacherNo];
        output.usageRate = (output.upperUsageData / output.lowerUsageData)* 100;
        output.containSingleClassOnAnyDay = !!getters['C40101/getWarningforSingleClassDayPerTeacher'][teacherNo];
        output.warnClassUsage = false;
        if(output.usageRate <= state.lowUsageRateTreshold) output.warnClassUsage = true
        if(getters['C40101/getWarningforSingleClassDayPerTeacher'][teacherNo]) output.warnClassUsage = true

        state.C40101_classUsageData[teacherNo] = output;
      }
      console.timeEnd('updateClassUsageDataForCurrentTeacher');
    }
  },
  actions: {
    clearSelection({ state,commit },{hideNotification}) {
      if (!hideNotification ) this._vm.$dialog.notify.info(window.vue.$i18n.t('C40101.C40101Store.Q0QG1eba0Ag-1pul2h5Qv'))
      commit('setState',{
        selectedLessonNo: null,
        selectedLessonExtraInfo: null
      })
    },
    async assignTeacher({ state, getters,commit }, { lesson, teacher,date,timeLimitNos,currentTeacherSchedulesByGroup }) {
      console.time('assignTeacher');
      if (!teacher) throw new Error('teacher is required');

      if (!lesson) lesson = getters.selectedLesson;
      if (!lesson) throw new Error('lesson is required');
      console.log(lesson, teacher,date)

      if(!getters.C40101_canEdit(date)) {
        this._vm.$dialog.notify.error(window.vue.$i18n.t('C40101.SelectedScheduleInfomation.Otxrk24nj4ovWqBuTen7j'))
        return;
      }
      const errorPreset = {
        // ole check, those error should not be shown on production
        date:{
          type:'error',
          message:window.vue.$i18n.t('C40101.C40101Store.o2GqMl4oKZFcSwWSzis2x')
        },
        timeLimitNo:{
          type:'error',
          message:window.vue.$i18n.t('C40101.C40101Store.82y39rODREvAC9qfoEC6M')
        },
        teacherScheduleFull:{
          type:'error',
          message:window.vue.$i18n.t('C40101.C40101Store.4tqL2oTrD9ACCvjmdNzKv')
        },

        // check
        ngTeacher:{
          type:'error',
          message:window.vue.$i18n.t('C40101.C40101Store._M3DgT91cMTW7fW-WTu6o')
        },
        NO_FIT: {
          type:'error',
          message:window.vue.$i18n.t('C40101.C40101Store.UeYA7RxNqavP7MvNwHm1h')
        },
        teacherGender:{
          type:'warn',
          message:window.vue.$i18n.t('C40101.C40101Store.vZ-jVJTx-k-juJ8SjxhxD')
        },
        teacherType:{
          type:'warn',
          message:window.vue.$i18n.t('C40101.C40101Store.43XgXVyK_6AlESKq2vCFz')
        },
        subject:{
          type:'warn',
          message:window.vue.$i18n.t('C40101.C40101Store.l09RhvNq_DSCzcqyEMA-0')
        },
      }

      const checkList = []

      const errorMessageList = [];

      // OLE check
      // 1. Check date
      if (date !== lesson.schedule_date) {
        errorMessageList.push({
          ...errorPreset.date,
          debug: 'Date needed : ' + date + '!==' +lesson.schedule_date
        });
      }
      if (!timeLimitNos.includes(lesson.time_limit_no)) {
        errorMessageList.push({
          ...errorPreset.timeLimitNo,
          debug: 'Time limit no needed : ' + timeLimitNos + '!==' +lesson.time_limit_no
        });
      }


      // 1. 申込コマの生徒がNG講師に設定されている講師コマを選択した場合
      const selectedLessonExtraInfo = state.selectedLessonExtraInfo || {};
      const excludeTeacher = selectedLessonExtraInfo.excludeTeacher;
      const debugCheckObj ={
        title: 'ngTeacher',
        need: null,
        actual: null,
        action:'Skip check, no exclude teacher'
      }

      if (excludeTeacher.length > 0) {
        const teacherNo = teacher.teacher_no;
        const isExclude = excludeTeacher.find(t => t.teacher_no === teacherNo);
        if (isExclude) {
          errorMessageList.push({
            ...errorPreset.ngTeacher,
            debug: 'NG teacher : ' + teacherNo
          });
          debugCheckObj.action = 'Error, exclude teacher found';
        }
        const excludeTeacherNos = excludeTeacher.map(t => t.teacher_no);
        debugCheckObj.need = excludeTeacherNos;
        debugCheckObj.actual = teacherNo;
      }
      checkList.push(debugCheckObj)

      // 2. 申込コマの授業が90分の場合、40分前半 or 40分後半 の講師コマを選択した場合
      const predictGridData = generateScheduleGrid(
        [...currentTeacherSchedulesByGroup,lesson]
      )
      // get predictGridData size , confirm is 2x2
      if(predictGridData.length !== 2 || predictGridData[0].length !== 2 || predictGridData[1].length !== 2){
        errorMessageList.push({
          ...errorPreset.NO_FIT,
          debug: 'Teacher schedule is full : ' + teacher.teacher_no
        });
      }

      // 3. 申込コマのt1010生徒基本.講師性別希望[1:男 2:女 3:未設定] と 講師コマのt2010講師基本.性別[1:男 2:女 3:未設定] を以下の通りチェックする。
      if(lesson.teacher_request !== 3 ){
        if (lesson.teacher_request !== teacher.sex){
          errorMessageList.push({
            ...errorPreset.teacherGender,
            debug: 'Teacher gender needed : ' + lesson.teacher_request + '!==' +teacher.sex
          });
        }
      }
      checkList.push({title: 'teacherGender', need: lesson.teacher_request, actual: teacher.sex});

      // 4. 申込コマのt1010生徒基本.講師希望タイプ[1:カジュアル 2:ストイック] と 講師コマのt2010講師基本.講師タイプ[1:カジュアル 2:ストイック] を以下の通りチェックする。
      if (lesson.teacher_request_type) {
        if (lesson.teacher_request_type !== teacher.teacher_type) {
          errorMessageList.push({
            ...errorPreset.teacherType,
            debug: 'Teacher type needed : ' + lesson.teacher_request_type + '!==' +teacher.teacher_type
          });
        }
      }
      checkList.push({title: 'teacherType', need: lesson.teacher_request_type, actual: teacher.teacher_type});

      // 5. 申込コマの科目と 選択した講師の指導科目をチェックする。
      // 5-1. 申込コマから、科目分類を決定する。
      // let subjectCategory = 0;
      // if (!lesson.school_year_code) throw new Error('DevError: school_year_code is required');
      // switch (true) {
      //   case (lesson.school_year_code <= 16):
      //     subjectCategory = "1"; // 小
      //     break;
      //   case (lesson.school_year_code <= 23):
      //     subjectCategory = "2"; // 中
      //     break;
      //   default:
      //     subjectCategory = "3"; // 高
      //     break;
      // }

      // if (lesson.school_year_code >= 31 && lesson.school_year_code <= 33) {
      //   subjectCategory += `,${lesson.school_year_code}`; // 高１～高３
      // }
      // subjectCategory += ",50"; // その他

      // 5-2. 申込コマの科目Noのm1020科目.科目区分＝1:単一科目の場合
      if(lesson.subject_type === 1){
        // const result = await $this.$api.postData({data:[{
        //   api: 'T3010ScheduleService.C40101_checkTeacherSubject',
        //   input: {
        //     subject_no: lesson.subject_no,
        //     teacher_no: teacher.teacher_no,
        //     subject_category: subjectCategory
        //   }
        // }]})
        // if (result[0].output[0].count === 0) {
        //   errorMessageList.push({
        //     ...errorPreset.subject,
        //     debug: 'Teacher subject needed : ' + lesson.subject_no + '!==' +teacher.subject_nos
        //   });
        // }
        // checkList.push({title: 'subject1', need: {
        //   subject_no: lesson.subject_no,
        //   teacher_no: teacher.teacher_no,
        //   subject_category: subjectCategory
        // }, actual: result[0].output[0]});

        if(!state.selectedLessonExtraInfo) throw new Error('selectedLessonExtraInfo is required');
        if(!state.selectedLessonExtraInfo.checkSubjectCountMapping[teacher.teacher_no].valid){
          // 3.5. check if teacher is available
          errorMessageList.push({
            ...errorPreset.subject,
            debug: '1 Teacher subject needed : ' + lesson.subject_no + '!==' +teacher.subject_nos
          });
        }
        checkList.push({title: 'subject1_test', need: {
          subject_no: lesson.subject_no,
          teacher_no: teacher.teacher_no,
        }, actual: state.selectedLessonExtraInfo.checkSubjectCountMapping[teacher.teacher_no]});
      }

      // 5-3. 申込コマの科目Noのm1020科目.科目区分＝2:複数科目 の場合
      if (lesson.subject_type === 2) {
        // const result = (await $this.$api.postData({data:[{
        //   api: 'T3010ScheduleService.C40101_checkTeacherSubject2',
        //   input: {
        //     subject_no: lesson.subject_no,
        //     teacher_no: teacher.teacher_no,
        //     subject_category: subjectCategory
        //   }
        // }]}))[0].output[0]
        // if (
        //   result.count === result.base_count && result.base_count > 0)
        // {
        //   // do ntg
        // } else {
        //   errorMessageList.push({
        //     ...errorPreset.subject,
        //     debug: 'Teacher subject needed : ' + lesson.subject_no + '!==' +teacher.subject_nos
        //   });
        // }
        // checkList.push({title: 'subject2', need: lesson.subject_no, actual: teacher.subject_nos});

        if(!state.selectedLessonExtraInfo) throw new Error('selectedLessonExtraInfo is required');
        if(!state.selectedLessonExtraInfo.checkSubjectCountMapping[teacher.teacher_no].valid2){
          // 3.5. check if teacher is available
          errorMessageList.push({
            ...errorPreset.subject,
            debug: '2 Teacher subject needed : ' + lesson.subject_no + '!==' +teacher.subject_nos
          });
        }
        checkList.push({title: 'subject2_test', need: {
          subject_no: lesson.subject_no,
          teacher_no: teacher.teacher_no,
        }, actual: state.selectedLessonExtraInfo.checkSubjectCountMapping[teacher.teacher_no]});
      }

      console.table(checkList)

      // check if errorMessageList contain type error
      if (errorMessageList.length > 0) {
        const errorMessage = errorMessageList.find(e => e.type === 'error');
        if (errorMessage) {
          this._vm.$dialog.notify.error(errorMessage.message)
          return false;
        }
      }
      // 6. 上記3.～5.で
      if (errorMessageList.length > 0) {
        // filter type warn
        // 6-1. 警告メッセージをすべて１つにまとめて確認メッセージを表示する。
        const warnMessageList = errorMessageList.filter(e => e.type === 'warn');
        console.log({warnMessageList})
        if (warnMessageList.length > 0) {
          let warnMsg = warnMessageList.map(e => e.message).join('\n');
          warnMsg = warnMsg + window.vue.$i18n.t('C40101.C40101Store.6wNWeBGhN6OHHwafiyXen');
          const result = await window.vue.$confirm({
            title: window.vue.$i18n.t('common.confirm'),
            text: warnMsg,
            persistent: true,
            actions: [
              { key: true, text: window.vue.$i18n.t('common.yes'), color: 'primary' },
              { key: false, text: window.vue.$i18n.t('common.no') },
            ]
          })
          if (!result) return false;

        }
        // 6-2. パスワードチェックを行うa
        const result = await this._vm.$dialog.prompt({
          title: window.vue.$i18n.t('C40101.AssignBtn.I0kiFL-U9xuE_pVFvARL4'),
          textField: {
            type: 'password',
            variant: 'outlined',
          },
          actions: [
            { key: true, text: 'OK', color: 'primary' },
            { key: false, text: window.vue.$i18n.t('common.cancel') },
          ]
        })

        if (!result) return false;

        const res = (await $this.$api.postData({
          data: [
            {
              api: 'AuthService.C40101_checkPassword',
              input: {
                user_password:result
              }
            },
          ]
        }))[0].output
        if(res == null){
          // password wrong
          this._vm.$dialog.notify.error(window.vue.$i18n.t('C40101.C40101Store.MdoRDipo4pvNUgKeEt5SX'))
          return false;
        }
        else{
          // password ok
        }
      }
      const lessonIndex = state.lessons.findIndex(l => l.schedule_no === lesson.schedule_no);
      let oldTeacherNo = null;
      if (lessonIndex !== -1) {
        oldTeacherNo = state.lessons[lessonIndex].teacher_no;
        state.lessons[lessonIndex] = {
          ...state.lessons[lessonIndex],
          teacher_no: teacher.teacher_no,
          _action: 'assignTeacher'
        };
      }

      commit('setState',{
        _removeReactivity : true,
        isDirty: true,
        lessons: state.lessons
      })
      commit('updateGridDataForCurrentTeacher',[
        oldTeacherNo,
        teacher.teacher_no
      ])
      commit('updateClassUsageDataForCurrentTeacher')

      console.timeEnd('assignTeacher');
    },
    removeTeacher({ state,commit }, { lesson }) {
      const lessonIndex = state.lessons.findIndex(l => l.schedule_no === lesson.schedule_no);
      let oldTeacherNo = null;
      if (lessonIndex !== -1) {
        oldTeacherNo = state.lessons[lessonIndex].teacher_no;
        state.lessons[lessonIndex] = {
          ...state.lessons[lessonIndex],
          teacher_no: 0,
          _action: 'removeTeacher'
        };
      }

      commit('setState',{
        _removeReactivity : true,
        isDirty: true,
        lessons: state.lessons
      })
      commit('updateGridDataForCurrentTeacher',[oldTeacherNo])
      commit('updateClassUsageDataForCurrentTeacher')
    },
    async C40101_setTransfer({ state,dispatch }, { lesson,targetCenterNo }) {
      // direct update backend
      await $this.$api.postData({
        data:[
          {
            api: 'T3010ScheduleService.C40101_setTransfer',
            input: {
              schedule: lesson,
              target_center_no: targetCenterNo
            }
          },
        ]
      })
      window.vue.$dialog.notify.success(window.vue.$i18n.t('C40101.C40101Store.iH41vdeFrVO6PSpe4eilN'),{
        timeout: 2000,
      });
      //  reload
      await dispatch('C40101_Init')
    },
    async C40101_removeTransfer({ state,dispatch }, { lesson }) {
      await $this.$api.postData({
        data:[
          {
            api: 'T3010ScheduleService.C40101_removeTransfer',
            input: {
              schedule: lesson,
            }
          },
        ]
      })
      window.vue.$dialog.notify.success(window.vue.$i18n.t('C40101.C40101Store.K8yIy9Z9otsu7qaRTH9KN'),{
        timeout: 2000,
      });
      //  reload
      await dispatch('C40101_Init')
    },
    // NOTE: may not be used, LetsCenterPicker
    async C40101_getDropdownData({ commit, state }) {
      const res = await $this.$api.postData({
        data: {
          groupCenters:{
            api: 'M0110CenterService.getCentersDropdown_ShortLabel',
            input: {group_flag: 1 },
          },
          centers:{
            api: 'M0110CenterService.getCentersDropdown_ShortLabel',
            input: {group_flag: 0},
          },
        }
      })
      commit('setState', {
        groupCenters: res.groupCenters.output,
        centers: res.centers.output
      })
    },
    async C40101_Init({ commit, state,dispatch }) {
      dispatch('clearSelection',{hideNotification:true})
      const payload = {
        start_date: state.searchInfo.date[0],
        end_date: state.searchInfo.date[1],
        center_no: state.searchInfo.center
      }
      state.updateKey = null
      state.errorNotificationMessage = null
      if(!payload.center_no) return

      const res = await $this.$api.postData({
        data: {
          C40101_canEdit:{
            api: 'T0050CalendarService.C40101_canEdit',
          },
          timeSlots:{
            api: 'T0050CalendarService.C40101_getCalendar',
            input: payload
          },
          teachers:{
            api: 'T2010TeacherBasicService.C40101_getTeacherInfoAndSchedule',
            input: payload
          },
          lessons:{
            api: 'T2010TeacherBasicService.C40101_getAppliedSchedule',
            input: payload
          },
          // student:{
          //   api: 'T1010StudentBasicService.C40101_getStudentList',
          //   input: {
          //     center_no: payload.center_no
          //   }
          // },
          t3014:{
            api: 'T3014ScheduleDeliveryService.C40101_getCourseStartDate',
            input: {
              center_no: payload.center_no
            }
          },
          main_t2030_teacher_schedule: {
            api: 'T2040TeacherScheduleService.C40101_getTeacherSchedule',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
          C40201_ALLOW_DOWNLOAD_PDF:{
            api: 'AuthService.getConfig',
            input: {key:'app.C40201_ALLOW_DOWNLOAD_PDF'}
          },
          C40201_ALLOW_DOWNLOAD_EXCEL:{
            api: 'AuthService.getConfig',
            input: {key:'app.C40201_ALLOW_DOWNLOAD_EXCEL'}
          },
          C40101T2050_rows:{
            api: 'T2050OthersScheduleService.C40101T2050_init',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no,
            }
          },
        }
      })
      try {
        commit('setState', {
          timeSlots: Object.freeze(res.timeSlots.output),
          teachers: Object.freeze(res.teachers.output),
          lessons: res.lessons.output,
          t3014: res.t3014.output,
          main_t2030_teacher_schedule: Object.freeze(res.main_t2030_teacher_schedule.output),
          C40101_canEdit_MinDate: res.C40101_canEdit.output.C40101_canEdit_MinDate,
          C40101_canEdit_MaxDate: res.C40101_canEdit.output.C40101_canEdit_MaxDate,
          C40201_ALLOW_DOWNLOAD_PDF: res.C40201_ALLOW_DOWNLOAD_PDF.output,
          C40201_ALLOW_DOWNLOAD_EXCEL: res.C40201_ALLOW_DOWNLOAD_EXCEL.output,
          C40101T2050_rows: res.C40101T2050_rows.output,
        })

        commit('setTeacherIsAvailableMap')
        commit('set_C40101T2050_map')
        commit('updateGridDataForCurrentTeacher')
        commit('updateClassUsageDataForCurrentTeacher')

        if (state.timeSlots.length === 0) {
          const msg = window.vue.$i18n.t('C40101.C40101Store.XdWGfRAyx-NxGbAoob6n7')
          commit('setState', {
            errorNotificationMessage : msg
          })
          return
        }
        commit('setState', {
          updateKey: new Date(),
          selectedLessonNo: null,
          selectedLessonExtraInfo: null,
          isDirty: false,
        })
      }
      catch (e) {
        window.vue.$dialog.notify.error('DevError:データの取得に失敗しました。')
        console.error(e)
      }
    },
    async C40101_getSelectedScheduleInfomation({ commit, state ,getters}) {
      const selectedLesson = getters.selectedLesson
      if(selectedLesson === undefined) return;
      commit('setState',{
        selectedLessonExtraInfo: 'loading'
      })
      const res = await $this.$api.postData({
        data: [
          {
            api: 'T3010ScheduleService.C40101_getSelectedScheduleInfomation',
            input: {
              schedule_date: selectedLesson.schedule_date,
              student_no: selectedLesson.student_no.toString() ?? null,
              center_no: selectedLesson.center_no.toString() ?? null,
              time_limit_no: selectedLesson.time_limit_no.toString() ?? null,

              start_date: state.searchInfo.date[0],
              end_date: state.searchInfo.date[1],
              subject_no: selectedLesson.subject_no.toString() ?? null,
              subject_type: selectedLesson.subject_type,
              school_year_code: selectedLesson.school_year_code,
            }
          },
        ]
      },false)
      // if (res[0].output.schedule_no !== state.selectedLessonNo) {
      //   throw new Error('Schedule no is not same')
      // }
      commit('setState',{
        selectedLessonExtraInfo: res[0].output
      })
    },
    async C40101_updateSchedule({ commit, state,dispatch,getters }, payload) {
      const res = await $this.$api.postData({
        data:{
          C40101_updateSchedule:{
            api: 'T3010ScheduleService.C40101_updateSchedule',
            input: state.lessons.filter(l => l._action === 'assignTeacher' || l._action === 'removeTeacher')
          },
          C40101_updateScheduleCheck_B00301:{
            api: 'T3010ScheduleService.C40101_updateScheduleCheck_B00301',
            input: {
              center_no: state.searchInfo.center,
              start_date: state.searchInfo.date[0],
              end_date: state.searchInfo.date[1],
            }
          },
          // ISSUE_HIGH: when C40101_updateSchedule gets error, C40101T2050_submit should not run
          C40101T2050_submit: getters.C40101T2050_submitApi
        },
        databaseDiff : {
          tables: ['t3010_schedule','t2050_others_schedule'],
        }
      })

      commit('setState', {
        C40101_updateScheduleCheck_B00301: res.C40101_updateScheduleCheck_B00301.output
      })

      const insertResult = res.C40101_updateSchedule.output
      const errorInsert = insertResult.filter(i => i.errorCode || i.error_content)
      if (errorInsert.length > 0) {
        const {
          error_code:errorCode,
          error_content:errorContent
        }  = errorInsert[0]
        LetsMessageMap[errorCode].render(window.vue,{
          errorMessage: errorContent,
        })
        return
      }
      const successInsert = insertResult.filter(i => i.code)
      if(successInsert.length > 0) {
        const {code} = successInsert[0]
        LetsMessageMap[code].render(window.vue)
        dispatch('C40101_Init')
        return
      }
      const noChange = insertResult.filter(i => i.noChange)
      if (noChange.length > 0) {
        window.vue.$dialog.notify.info(window.vue.$i18n.t('C40101.C40101Store._7BpMrp5wblUwJd-tlB1A'))
        return
      }

      const C40101T2050 = state.C40101T2050_rows.filter(r => r._action === 'insert' || r._action === 'update' || r._action === 'delete')
      if(C40101T2050.length > 0){
        window.vue.$dialog.notify.info(window.vue.$i18n.t('C40101.C40101Store.0sVSxnSPda9bMLdqnUePf'))
        dispatch('C40101_Init')
        return
      }

      throw new Error('Unknown error');
    },
    async C40101_checkPassword({ commit, state }, payload) {
      const res = await $this.$api.postData({
        data: [
          {
            api: 'AuthService.C40101_checkPassword',
            input: payload
          },
        ]
      })

      return res[0].output
    },
    async C40101_resetSchedule({ commit, state }, payload) {
      const res = await $this.$api.postData({
        data: [
          {
            api: 'T3010ScheduleService.C40101_resetSchedule',
            input: payload
          },
        ]
      })

      return res[0].output ?? []
    },
    async C40101_getLatestScheduleNoForReport({ commit, state }, payload) {
      const res = await $this.$api.postData({
        data: [
          {
            api: 'T3010ScheduleService.C40101_getLatestScheduleNoForReport',
            input: payload
          },
        ]
      })
      return res[0].output ?? []
    },
    async C40101_cancelSchedule_SingleCell({ state }, payload) {
      const res = await $this.$api.postData({
        data: [
          {
            api: 'T3010ScheduleService.C40101_cancelSchedule_SingleCell',
            input: payload
          },
        ],
        databaseDiff : {
          tables: ['t3010_schedule','t3015_cancel_schedule','t1031_entry_schedule'],
        }
      })
      return res[0].output ?? []
    },
    async C40101_setTeacherType({state},payload){
      const res = await $this.$api.postData({
        data: [
          {
            api: 'T2010TeacherBasicService.C40101_setTeacherType',
            input: payload
          },
        ]
      })
      return res[0].output ?? []
    },
    async C40101_distribute({state}, payload){
      const res = await $this.$api.postData({
        data: [
          {
            api: 'T3014ScheduleDeliveryService.C40101_distribute',
            input: payload
          },
        ]
      })
      return res[0].output ?? []
    },
    async C40201_downloadPdf({state}, payload){
      const res = await $this.$api.postData({
        data: {
          C40201_generatePDF:{
            api: 'T3010ScheduleService.C40201_generatePDF',
            input: {
              file_name: payload.file_name,
              html:payload.html
            }
          },
        }
      })
      if (res.C40201_generatePDF.output) {
        const fileUrl=res.C40201_generatePDF.output.url

        const a = $('<a>')
          .attr('href',fileUrl)
          .attr('target', 'download')
          .appendTo('body')
        a[0].click()
        a.remove()
      }
    }
  },
}



export default ObjArrUtils.merge(Base, module, C40101T2050Module )
